// extracted by mini-css-extract-plugin
export default {"testing_accordion_wrapper":"TestingAccordion_testing_accordion_wrapper__SeM5Z","error":"TestingAccordion_error__cHV0O"};